<template>
    <h3 class="panel-title">
        <slot></slot>
    </h3>
</template>

<script>
export default {
    name: 'panelTitle',
}
</script>

<style scoped>
.panel-title {
    margin: 0;
    padding: 0;
    font-family: var(--font-family-primary);
    font-size: var(--text-md);
    font-weight: bold;
    color: var(--color-primary);
    letter-spacing: 0.5px;
    text-transform: uppercase;
    text-align: left;
}
</style>